import React from "react"

import ofertaStyles from "./oferta.module.scss"

const Oferta = () => {
  return (
    <div className={ofertaStyles.oferta} id="oferta">
      <h2>oferta</h2>

      <div className={ofertaStyles.iconbox}>
        <div className={ofertaStyles.item}>
          <img src={require("../img/mdi_wc.svg")} alt="oferta ikona"></img>
          <p>reportaże ślubne</p>
        </div>
        <div className={ofertaStyles.item}>
          <img src={require("../img/mdi_account_box.svg")} alt="oferta ikona"></img>
          <p>Portrety</p>
        </div>
        <div className={ofertaStyles.item}>
          <img src={require("../img/mdi_child_friendly.svg")} alt="oferta ikona"></img>
          <p>Sesje rodzinne i noworodkowe</p>
        </div>
        <div className={ofertaStyles.item}>
          <img src={require("../img/mdi_airplanemode_active.svg")} alt="oferta ikona"></img>
          <p>Fotografia podróżnicza</p>
        </div>
        <div className={ofertaStyles.item}>
          <img src={require("../img/mdi_photo_camera.svg")} alt="oferta ikona"></img>
          <p>Artystyczne</p>
        </div>
      </div>
    </div>
  )
}
export default Oferta
